'use strict';

exports.__esModule = true;
exports.ReduxModel = undefined;

var _reduceHandlers;

exports.viasReducer = viasReducer;
exports.viasConnect = viasConnect;

var _Model2 = require('./Model');

var _Model3 = _interopRequireDefault(_Model2);

var _Depend = require('./Depend');

var _Depend2 = _interopRequireDefault(_Depend);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INIT_MODELS = 'VIAS/INIT_MODELS';

function initModels(models) {
  return {
    type: INIT_MODELS,
    models: models
  };
}

var MODEL_UPDATE = 'VIAS/MODEL_UPDATE';

function updateModel(model, event) {
  return {
    type: MODEL_UPDATE,
    model: model,
    event: event
  };
}

var reduceHandlers = (_reduceHandlers = {}, _reduceHandlers[INIT_MODELS] = function (state, _ref) {
  var models = _ref.models;

  var newState = Object.assign({}, state);
  for (var _iterator = models, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref2;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref2 = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref2 = _i.value;
    }

    var model = _ref2;

    // If model already exists in redux(state sent from server), keep its cache
    if (newState[model.name]) {
      newState[model.name] = Object.assign(model, {
        docs: newState[model.name].docs,
        customResults: newState[model.name].customResults
      });
    } else {
      newState[model.name] = model;
    }
  }
  return newState;
}, _reduceHandlers[MODEL_UPDATE] = function (state, _ref3) {
  var _Object$assign;

  var model = _ref3.model;

  var newState = Object.assign({}, state, (_Object$assign = {}, _Object$assign[model.name] = model.snapshot(), _Object$assign));
  return newState;
}, _reduceHandlers);

function viasReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var handler = reduceHandlers[action.type];
  if (handler) {
    return handler(state, action);
  } else {
    return state;
  }
}

var ReduxModel = exports.ReduxModel = function (_Model) {
  _inherits(ReduxModel, _Model);

  ReduxModel.connect = function connect(store, model) {
    if (!(model instanceof _Model3.default)) {
      throw new Error('Cannot connect non Vias Model');
    }
    var newModel = new ReduxModel(store, model.name, model.aliases, model.methods, model.custom);
    // Depend model function
    newModel.set = model.set;
    newModel.run = model.run;
    return newModel;
  };

  function ReduxModel(store, name) {
    var aliases = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var methods = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var custom = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

    _classCallCheck(this, ReduxModel);

    var _this = _possibleConstructorReturn(this, _Model.call(this, name, aliases, methods, custom));

    _this.storeGetState = store.getState;
    _this.storeDispatch = store.dispatch;
    return _this;
  }

  ReduxModel.prototype._broadcast = function _broadcast(event) {
    // When promises get resolved/update, dispatch a redux action and update the state
    this.storeDispatch(updateModel(this, event));
  };

  ReduxModel.prototype.snapshot = function snapshot() {
    // Get new copy of the model for new redux state
    return Object.assign({}, this, { docs: (0, _util.clone)(this.docs), customResults: (0, _util.clone)(this.customResults) });
  };

  return ReduxModel;
}(_Model3.default);

function viasConnect(store) {
  for (var _len = arguments.length, models = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    models[_key - 1] = arguments[_key];
  }

  models.push(_Depend2.default);
  var reduxModels = models.map(function (model) {
    return ReduxModel.connect(store, model);
  });
  store.dispatch(initModels(reduxModels));
}


//////////////////
// WEBPACK FOOTER
// ./~/vias/lib/redux.js
// module id = 569
// module chunks = 15